import $ from 'jquery';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const slider1 = new Swiper('.js-swiper-list3', {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

/* slide1
/*---------------------------------------------------------*/

let swiperpreson;
let slide1 = $(".js-slide1");
if (slide1.length) {
  swiperpreson = new Swiper('.js-swiper1', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    pagination: {
      el: ".js-swiper-pagi1",
      type: "fraction",
    },
    navigation: {
      nextEl: ".js-swiper-prev1",
      prevEl: ".js-swiper-next1",
    },
    // thumbs: {
    //   swiper: modalSwiper,
    // },
  });

  new Swiper('.js-swiper2', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: false,
    pagination: {
      el: ".js-swiper-pagi2",
      type: "fraction",
    },
    navigation: {
      nextEl: ".js-swiper-prev2",
      prevEl: ".js-swiper-next2",
    },
  });
}
//c-block14
$(window).on("load", function (e) {
  if ($(window).outerWidth() < 768) {
    let blockSlide3 = $('.js-slide3-content');

    blockSlide3.addClass('swiper');
    blockSlide3.find('.c-block14__list1').addClass('swiper-wrapper');
    blockSlide3.find('.c-block14__item1').addClass('swiper-slide');


    let i = 1;
    $(".js-slide3").each(function () {
      $(this).addClass("is-slider3" + i);
      var thumbs = ".is-slider3" + i + " .js-slide3-thumb";
      var content = ".is-slider3" + i + " .js-slide3-content";
      var pagination = ".is-slider3" + i + " .swiper-pagination";

      var slider1__thumb = new Swiper(thumbs, {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 'auto',
      });

      new Swiper(content, {
        loop: false,
        slidesPerView: 1,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
          type: "custom",
          renderCustom: function (swiper, current, total) {
            if (current < 10 || total < 10) {
              current = '0' + current;
              total = '0' + total;
            }
            return current + '/' + total;
          }
        },
        thumbs: {
          swiper: slider1__thumb,
        },
      });
      i++;
    });
  } else { }
});


/* slide10
/*---------------------------------------------------------*/
let modalSwiper;
let slide10 = $(".js-slide10");
if (slide10.length) {
  modalSwiper = new Swiper('.js-swiper10', {
    slidesPerView: 1,
    loop: false,
    navigation: {
      nextEl: ".js-swiper-prev10",
      prevEl: ".js-swiper-next10",
    },
    // thumbs: {
    //   swiper: swiperpreson,
    // },
  });
}
if ($('main').hasClass('p-person')) {
  swiperpreson.controller.control = modalSwiper;
  modalSwiper.controller.control = swiperpreson;
}